module.exports = __webpack_public_path__ + "img/Type_Fighting.eae89a0e.png";